import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';
import { MotionPathPlugin } from 'gsap/MotionPathPlugin';

export default class GSAPAnimations {

    constructor() {
        this.bindUIActions();
    }

    bindUIActions() {

        gsap.registerPlugin(ScrollTrigger);

        ScrollTrigger.defaults({
            toggleActions: 'restart pause resume none'
        });

        // General
        if($('.js-text-reveal-right').length) {
            gsap.from('.js-text-reveal-right', {
                scrollTrigger: '.js-text-reveal-right',
                stagger: 0.75,
                opacity: 0,
                x: 150,
                duration: 1.5
            })
        }

        if($('.js-text-reveal-left').length) {
            gsap.from('.js-card-reveal-left', {
                scrollTrigger: '.js-card-reveal-left',
                opacity: 0,
                x: -150,
                duration: 1.5
            })
        }

        // Newsletter
        if($('.js-newsletter-img').length) {
            gsap.from('.js-newsletter-img', {
                scrollTrigger: '.js-newsletter-img',
                x: -200,
                duration: 3,
                opacity: 0,
                ease: 'power4.inOut'
            });
        }

        // Plane
        gsap.registerPlugin(DrawSVGPlugin);
        gsap.registerPlugin(MotionPathPlugin);

        let targets = gsap.utils.toArray("#maskReveal path"); 
        let appendGroup = document.querySelector("#theMask");

        targets.forEach((obj, i) => {
            let clone = obj.cloneNode(true);
            clone.removeAttribute("stroke-dasharray");
            gsap.set(clone, { attr: { stroke: "white" }, drawSVG: 0 });
            appendGroup.appendChild(clone);
        });

        if($("#theMask path").length) {
            gsap.to("#theMask path", {
                duration: 2,
                repeat: false,
                repeatDelay: 0.4,
                yoyo: false,
                ease: "none",
                stagger: 0.25,
                drawSVG: true,
                paused: true,
            });
        }

        if($('.arrow').length) {
            const animation = gsap.to(".arrow", {
                duration: 2,
                ease: "none",
                motionPath: {
                    path: "#maskReveal path",
                    align: "#maskReveal path",
                    alignOrigin: [0.5, 0.5],
                    autoRotate: true,
                },
                onStart: () => {
                    gsap.to("#theMask path", {
                        duration: 2,
                        repeat: false,
                        repeatDelay: 0.4,
                        yoyo: false,
                        ease: "none",
                        stagger: 0.25,
                        drawSVG: true,
                    });
                },
                paused: true,
            });

            ScrollTrigger.create({
                trigger: "[data-block='newsletter-subscription']" ,
                start: "top-=200px 90%",
                onEnter: () => {
                    if (!gsap.isTweening("#theMask path") && !gsap.isTweening(".arrow")) {
                        gsap.to("#theMask path", { duration: 2, drawSVG: true, ease: "none" });
                        animation.play();
                    }
                },
                once: true,
            });
        }
    }

};

new GSAPAnimations();